module.exports = __webpack_public_path__ + "static/img/x-icon-01.d435986.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/x-icon-01.png
// module id = BAK5
// module chunks = 7